export default __webpack_public_path__ + "static/media/pinterest-icon-2.f8e5832a.svg";